import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import PageSeo from '../components/PageSeo';
import { SEO } from '../utils/seoConfig';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#F5F5F5] py-12">
      <PageSeo {...SEO.privacyPolicy} />
      <div className="container mx-auto px-4 max-w-4xl">
        <Card>
          <CardContent className="p-8">
            <h1 className="text-4xl font-bold text-[#0A2540] mb-6">
              Politique de Confidentialité
            </h1>
            
            <p className="text-sm text-gray-500 mb-8">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>

            <div className="space-y-6 text-gray-700">
              {/* Introduction */}
              <section>
                <p className="mb-3">
                  GEO TS CONSULTING (ci-après "nous", "notre"), SAS immatriculée sous le numéro SIRET 993 093 772 00016, s&apos;engage à protéger et respecter votre vie privée. Cette Politique de Confidentialité explique comment nous collectons, utilisons, partageons et protégeons vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD - UE 2016/679).
                </p>
              </section>

              {/* Article 1 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  1. Responsable du Traitement
                </h2>
                <p className="mb-3">
                  Le responsable du traitement de vos données personnelles est :
                </p>
                <ul className="list-none ml-4 space-y-2">
                  <li><strong>Société :</strong> GEO TS CONSULTING (GEO TECHNICAL SPARES)</li>
                  <li><strong>Forme juridique :</strong> SAS</li>
                  <li><strong>SIRET :</strong> 993 093 772 00016</li>
                  <li><strong>Adresse :</strong> 26 Rue des Rigoles, 75020 PARIS, France</li>
                  <li><strong>Email :</strong> contact@geots.consulting</li>
                  <li><strong>Téléphone :</strong> +33 1 64 40 95 27</li>
                  <li><strong>Délégué à la Protection des Données (DPO) :</strong> privacy@geots.consulting</li>
                </ul>
              </section>

              {/* Article 2 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  2. Données Collectées
                </h2>
                
                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  2.1 Données fournies directement
                </h3>
                <p className="mb-3">Lors de votre inscription et utilisation de la plateforme, nous collectons :</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li><strong>Informations de compte :</strong> nom, prénom, email, mot de passe (crypté), téléphone</li>
                  <li><strong>Informations professionnelles :</strong> nom de société, fonction, adresse professionnelle, SIRET</li>
                  <li><strong>Informations de paiement :</strong> coordonnées bancaires (traitées via prestataire sécurisé)</li>
                  <li><strong>Contenu publié :</strong> descriptions de produits, photos, avis, messages</li>
                </ul>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  2.2 Données collectées automatiquement
                </h3>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li><strong>Données de connexion :</strong> adresse IP, type de navigateur, système d'exploitation</li>
                  <li><strong>Données de navigation :</strong> pages visitées, durée des visites, actions effectuées</li>
                  <li><strong>Cookies :</strong> identifiants de session, préférences utilisateur</li>
                  <li><strong>Géolocalisation :</strong> ville/pays (via IP ou saisie manuelle)</li>
                </ul>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  2.3 Données d'interaction
                </h3>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Historique des commandes et devis</li>
                  <li>Avis et évaluations publiés</li>
                  <li>Messages échangés avec d'autres utilisateurs</li>
                  <li>Statistiques de consultation (vues, clics) pour l'annuaire professionnel</li>
                </ul>
              </section>

              {/* Article 3 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  3. Finalités et Bases Légales du Traitement
                </h2>
                
                <div className="overflow-x-auto">
                  <table className="min-w-full border-collapse border border-gray-300 text-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="border border-gray-300 px-4 py-2 text-left">Finalité</th>
                        <th className="border border-gray-300 px-4 py-2 text-left">Base légale</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2">Création et gestion de compte</td>
                        <td className="border border-gray-300 px-4 py-2">Exécution du contrat</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2">Traitement des commandes et devis</td>
                        <td className="border border-gray-300 px-4 py-2">Exécution du contrat</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2">Communication avec les utilisateurs</td>
                        <td className="border border-gray-300 px-4 py-2">Exécution du contrat</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2">Amélioration des services</td>
                        <td className="border border-gray-300 px-4 py-2">Intérêt légitime</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2">Envoi de newsletters et offres</td>
                        <td className="border border-gray-300 px-4 py-2">Consentement</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2">Statistiques et analyses</td>
                        <td className="border border-gray-300 px-4 py-2">Intérêt légitime</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2">Prévention de la fraude</td>
                        <td className="border border-gray-300 px-4 py-2">Intérêt légitime</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2">Obligations légales et fiscales</td>
                        <td className="border border-gray-300 px-4 py-2">Obligation légale</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              {/* Article 4 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  4. Destinataires des Données
                </h2>
                <p className="mb-3">Vos données personnelles peuvent être transmises à :</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li><strong>Personnel autorisé :</strong> Employés de GEO TS CONSULTING ayant besoin d'accéder aux données pour leurs fonctions</li>
                  <li><strong>Autres utilisateurs :</strong> Informations de profil public, avis publiés</li>
                  <li><strong>Prestataires techniques :</strong> Hébergement (OVHcloud), paiement (Stripe), emailing (sous contrat de confidentialité)</li>
                  <li><strong>Autorités :</strong> Sur réquisition judiciaire ou obligation légale</li>
                </ul>
                <p className="mt-3">
                  <strong>Nous ne vendons jamais vos données personnelles à des tiers.</strong>
                </p>
              </section>

              {/* Article 5 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  5. Durée de Conservation
                </h2>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li><strong>Compte actif :</strong> Pendant toute la durée d&apos;utilisation du service</li>
                  <li><strong>Compte inactif :</strong> 3 ans après la dernière connexion</li>
                  <li><strong>Données de commande :</strong> 10 ans (obligations comptables et fiscales)</li>
                  <li><strong>Cookies :</strong> 13 mois maximum</li>
                  <li><strong>Logs de connexion :</strong> 1 an (sécurité)</li>
                </ul>
              </section>

              {/* Article 6 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  6. Vos Droits
                </h2>
                <p className="mb-3">
                  Conformément au RGPD, vous disposez des droits suivants sur vos données personnelles :
                </p>
                
                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  6.1 Droit d&apos;accès
                </h3>
                <p>Vous pouvez demander une copie de toutes les données vous concernant.</p>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  6.2 Droit de rectification
                </h3>
                <p>Vous pouvez corriger ou mettre à jour vos données inexactes ou incomplètes.</p>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  6.3 Droit à l'effacement ("droit à l'oubli")
                </h3>
                <p>Vous pouvez demander la suppression de vos données, sous réserve de nos obligations légales.</p>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  6.4 Droit à la limitation du traitement
                </h3>
                <p>Vous pouvez demander le gel temporaire de vos données dans certains cas.</p>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  6.5 Droit à la portabilité
                </h3>
                <p>Vous pouvez recevoir vos données dans un format structuré et les transférer à un autre service.</p>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  6.6 Droit d'opposition
                </h3>
                <p>Vous pouvez vous opposer au traitement de vos données pour des raisons tenant à votre situation particulière.</p>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  6.7 Droit de retirer votre consentement
                </h3>
                <p>Pour les traitements basés sur le consentement (newsletters), vous pouvez le retirer à tout moment.</p>

                <div className="mt-4 p-4 bg-blue-50 border-l-4 border-blue-500">
                  <p className="font-semibold mb-2">Comment exercer vos droits ?</p>
                  <p>Envoyez votre demande par email à : <strong>privacy@geotsconsulting.com</strong></p>
                  <p className="text-sm mt-2">Nous répondrons dans un délai de 1 mois maximum.</p>
                </div>
              </section>

              {/* Article 7 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  7. Cookies et Technologies Similaires
                </h2>
                
                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  7.1 Types de cookies utilisés
                </h3>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li><strong>Cookies essentiels :</strong> Nécessaires au fonctionnement (session, authentification)</li>
                  <li><strong>Cookies de préférence :</strong> Mémorisation de vos choix (langue, panier)</li>
                  <li><strong>Cookies analytiques :</strong> Analyse de l&apos;utilisation (Google Analytics)</li>
                  <li><strong>Cookies marketing :</strong> Publicité ciblée (avec votre consentement)</li>
                </ul>

                <h3 className="text-xl font-semibold text-[#0A2540] mb-2 mt-4">
                  7.2 Gestion des cookies
                </h3>
                <p>Vous pouvez gérer vos préférences cookies via :</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>La bannière de consentement lors de votre première visite</li>
                  <li>Les paramètres de votre navigateur</li>
                  <li>Notre centre de préférences cookies (à venir)</li>
                </ul>
              </section>

              {/* Article 8 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  8. Sécurité des Données
                </h2>
                <p className="mb-3">
                  Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données :
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Chiffrement SSL/TLS pour toutes les communications</li>
                  <li>Mots de passe cryptés (hachage bcrypt)</li>
                  <li>Accès restreint aux données personnelles</li>
                  <li>Sauvegardes régulières et sécurisées</li>
                  <li>Tests de sécurité réguliers</li>
                  <li>Formation du personnel à la protection des données</li>
                </ul>
              </section>

              {/* Article 9 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  9. Transferts Internationaux
                </h2>
                <p>
                  Vos données sont hébergées dans l'Union Européenne. En cas de transfert hors UE, nous nous assurons qu'un niveau de protection adéquat est garanti (clauses contractuelles types, Privacy Shield, etc.).
                </p>
              </section>

              {/* Article 10 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  10. Mineurs
                </h2>
                <p>
                  Notre service est destiné aux professionnels majeurs. Nous ne collectons pas sciemment de données de personnes de moins de 18 ans. Si vous pensez qu'un mineur a fourni des données, contactez-nous immédiatement.
                </p>
              </section>

              {/* Article 11 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  11. Modifications de la Politique
                </h2>
                <p>
                  Nous pouvons modifier cette Politique de Confidentialité. Les modifications importantes vous seront notifiées par email ou notification sur la plateforme. La date de dernière mise à jour est indiquée en haut de ce document.
                </p>
              </section>

              {/* Article 12 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  12. Réclamation auprès de la CNIL
                </h2>
                <p className="mb-3">
                  Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) :
                </p>
                <ul className="list-none ml-4 space-y-2">
                  <li>🌐 Site web : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#635BFF] hover:underline">www.cnil.fr</a></li>
                  <li>📧 Email : via le formulaire en ligne</li>
                  <li>✉️ Courrier : CNIL, 3 Place de Fontenoy - TSA 80715, 75334 PARIS CEDEX 07</li>
                </ul>
              </section>

              {/* Article 13 */}
              <section>
                <h2 className="text-2xl font-bold text-[#0A2540] mb-3">
                  13. Contact
                </h2>
                <p className="mb-3">
                  Pour toute question concernant cette Politique de Confidentialité ou l'exercice de vos droits :
                </p>
                <ul className="list-none ml-4 space-y-2">
                  <li>📧 Email : privacy@geots.consulting</li>
                  <li>📞 Téléphone : +33 1 64 40 95 27</li>
                  <li>✉️ Courrier : GEO TS CONSULTING - Service Protection des Données - 26 Rue des Rigoles, 75020 PARIS</li>
                </ul>
              </section>
            </div>

            {/* Retour */}
            <div className="mt-12 pt-6 border-t">
              <Link 
                to="/" 
                className="text-[#635BFF] hover:text-[#5248d9] font-semibold inline-flex items-center"
              >
                ← Retour à l'accueil
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
